import React from 'react';
import DressReceivedFunctional from './components/dress-received-report-list-functional';
import './dress-received-report.scss';

const DressReceived = () => {
	return <DressReceivedFunctional />;
};

export default DressReceived;
